(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-promotion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-promotion')) {
    class CartPromotion extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', (event) => this.handleVariantChange(event));
      }

      handleVariantChange(event) {
        const select = event.target.closest('[data-cart-promotion-variant]');
        if (!select) return;
        const card = select.closest('[data-cart-promotion-card]');
        const option = select.selectedOptions[0];
        if (!card || !option) return;

        const price = card.querySelector('[data-cart-promotion-price]');
        const compare = card.querySelector('[data-cart-promotion-compare]');
        const image = card.querySelector('[data-cart-promotion-image]');

        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.comparePrice || '';
          compare.hidden = !option.dataset.comparePrice;
        }
        if (image && option.dataset.imageSrc) {
          image.removeAttribute('srcset');
          image.src = option.dataset.imageSrc;
          image.alt = option.dataset.imageAlt || image.alt;
        }
      }
    }

    customElements.define('cart-promotion', CartPromotion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('country-selector')) {
    class CountrySelector extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        const options = { signal: this.controller.signal };

        this.details?.addEventListener('toggle', () => this.handleToggle(), options);
        document.addEventListener('click', (event) => this.handleOutsideClick(event), options);
        document.addEventListener('keydown', (event) => this.handleKeydown(event), options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      handleToggle() {
        if (!this.details?.open) return;

        document.querySelectorAll('country-selector details[open]').forEach((details) => {
          if (details !== this.details) details.removeAttribute('open');
        });
      }

      handleOutsideClick(event) {
        if (this.details?.open && !this.contains(event.target)) this.close();
      }

      handleKeydown(event) {
        if (event.key !== 'Escape' || !this.details?.open) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.close(true);
      }

      close(restoreFocus = false) {
        if (!this.details?.open) return;
        this.details.removeAttribute('open');
        if (restoreFocus) this.trigger?.focus();
      }
    }

    customElements.define('country-selector', CountrySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.imageSwapToken = 0;
        this.pendingImage = null;

        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-product-card-swatch]');
          if (!swatch) return;

          this.querySelectorAll('[data-product-card-swatch]').forEach((option) => {
            const isSelected = option === swatch;
            option.classList.toggle('is-selected', isSelected);
            option.setAttribute('aria-pressed', String(isSelected));
          });

          this.swapImage(swatch);
        });
      }

      settlePendingImage() {
        const currentImage = this.querySelector('[data-product-card-image]');
        const pendingImage = this.pendingImage;

        if (!pendingImage) return currentImage;

        if (pendingImage.classList.contains('is-visible')) {
          currentImage?.remove();
          pendingImage.classList.remove('product-card__image--incoming', 'is-visible');
          pendingImage.setAttribute('data-product-card-image', '');
          pendingImage.alt = pendingImage.productCardTargetAlt;
          pendingImage.removeAttribute('aria-hidden');
          this.pendingImage = null;
          return pendingImage;
        }

        pendingImage.remove();
        currentImage?.classList.remove('product-card__image--outgoing');
        this.pendingImage = null;
        return currentImage;
      }

      commitImage(currentImage, incomingImage) {
        currentImage?.remove();
        incomingImage.classList.remove('product-card__image--incoming', 'is-visible');
        incomingImage.setAttribute('data-product-card-image', '');
        incomingImage.alt = incomingImage.productCardTargetAlt;
        incomingImage.removeAttribute('aria-hidden');
        this.pendingImage = null;
      }

      async swapImage(swatch) {
        if (!swatch.dataset.imageSrc) return;

        const swapToken = ++this.imageSwapToken;
        const currentImage = this.settlePendingImage();
        const media = currentImage?.closest('.product-card__media');
        if (!currentImage || !media) return;

        if (currentImage.getAttribute('src') === swatch.dataset.imageSrc) return;

        const incomingImage = currentImage.cloneNode(false);
        incomingImage.removeAttribute('data-product-card-image');
        incomingImage.classList.remove('product-card__image--outgoing');
        incomingImage.classList.add('product-card__image--incoming');
        incomingImage.productCardTargetAlt = swatch.dataset.imageAlt;
        incomingImage.alt = '';
        incomingImage.setAttribute('aria-hidden', 'true');
        incomingImage.srcset = swatch.dataset.imageSrcset;
        incomingImage.src = swatch.dataset.imageSrc;
        this.pendingImage = incomingImage;
        media.append(incomingImage);

        try {
          if (typeof incomingImage.decode === 'function') {
            await incomingImage.decode();
          } else if (!incomingImage.complete) {
            await new Promise((resolve, reject) => {
              incomingImage.addEventListener('load', resolve, { once: true });
              incomingImage.addEventListener('error', reject, { once: true });
            });
          }
        } catch {
          if (this.pendingImage === incomingImage) {
            incomingImage.remove();
            this.pendingImage = null;
          }
          return;
        }

        if (swapToken !== this.imageSwapToken || this.pendingImage !== incomingImage) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
          this.commitImage(currentImage, incomingImage);
          return;
        }

        await new Promise((resolve) => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (swapToken !== this.imageSwapToken || this.pendingImage !== incomingImage) {
                resolve();
                return;
              }

              const finishTransition = (event) => {
                if (event && event.propertyName !== 'opacity') return;
                incomingImage.removeEventListener('transitionend', finishTransition);
                resolve();
              };

              incomingImage.addEventListener('transitionend', finishTransition);
              window.setTimeout(finishTransition, 220);
              currentImage.classList.add('product-card__image--outgoing');
              incomingImage.classList.add('is-visible');
            });
          });
        });

        if (swapToken !== this.imageSwapToken || this.pendingImage !== incomingImage) return;
        this.commitImage(currentImage, incomingImage);
      }
    }

    customElements.define('product-card', ProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lampeek-review-carousel')) {
    class LampeekReviewCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.dots = [...this.querySelectorAll('[data-review-progress] span')];
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.track = this.querySelector('.pdp-review-carousel__track');
        this.activeSlide = 0;
        this.isAnimating = false;
        this.pointerStartX = null;

        this.previousButton?.addEventListener('click', () => this.showSlide(this.activeSlide - 1));
        this.nextButton?.addEventListener('click', () => this.showSlide(this.activeSlide + 1));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showSlide(this.activeSlide - 1);
          if (event.key === 'ArrowRight') this.showSlide(this.activeSlide + 1);
        });
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.pointerStartX = event.clientX;
        });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null) return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) < 40) return;
          this.showSlide(this.activeSlide + (distance < 0 ? 1 : -1));
        });
        this.addEventListener('pointercancel', () => {
          this.pointerStartX = null;
        });

        this.showSlide(0, false);
      }

      showSlide(nextIndex, shouldAnimate = true) {
        if (!this.slides.length || this.isAnimating) return;
        const nextSlideIndex = (nextIndex + this.slides.length) % this.slides.length;
        const previousSlideIndex = this.activeSlide;
        const previousSlide = this.slides[previousSlideIndex];
        const nextSlide = this.slides[nextSlideIndex];
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!shouldAnimate || prefersReducedMotion || nextSlideIndex === previousSlideIndex) {
          this.setActiveSlide(nextSlideIndex);
          return;
        }

        const direction = nextIndex > previousSlideIndex ? 'next' : 'previous';
        this.isAnimating = true;
        nextSlide.hidden = false;
        this.track?.style.setProperty('min-height', `${Math.max(previousSlide.offsetHeight, nextSlide.offsetHeight)}px`);
        previousSlide.classList.add('is-leaving', `is-${direction}`);
        nextSlide.classList.add('is-entering', `is-${direction}`);
        previousSlide.setAttribute('aria-hidden', 'true');
        nextSlide.setAttribute('aria-hidden', 'false');
        this.activeSlide = nextSlideIndex;
        this.updateControls();

        const finishTransition = (event) => {
          if (event.target !== nextSlide) return;
          previousSlide.hidden = true;
          previousSlide.classList.remove('is-leaving', 'is-next', 'is-previous');
          nextSlide.classList.remove('is-entering', 'is-next', 'is-previous');
          this.track?.style.removeProperty('min-height');
          this.isAnimating = false;
        };
        nextSlide.addEventListener('animationend', finishTransition, { once: true });
      }

      setActiveSlide(index) {
        this.activeSlide = index;
        this.slides.forEach((slide, index) => {
          slide.hidden = index !== this.activeSlide;
          slide.classList.remove('is-entering', 'is-leaving', 'is-next', 'is-previous');
          slide.setAttribute('aria-hidden', index === this.activeSlide ? 'false' : 'true');
        });
        this.updateControls();
      }

      updateControls() {
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.activeSlide));
        const hasMultipleSlides = this.slides.length > 1;
        if (this.previousButton) this.previousButton.disabled = !hasMultipleSlides;
        if (this.nextButton) this.nextButton.disabled = !hasMultipleSlides;
      }
    }

    customElements.define('lampeek-review-carousel', LampeekReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
